/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zoom_OutInputs */



/**
* | output |
* | --- |
* | "Zoom out" |
*
* @param {Zoom_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom_out = /** @type {((inputs?: Zoom_OutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zoom_OutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Zoom arrière")
	if (locale === "de") return /** @type {LocalizedString} */ ("Herauszoomen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimpicciolisci")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отдалиться")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alejar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("缩小")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ズームアウト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ज़ूम आउट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diminuir o zoom")
	return /** @type {LocalizedString} */ ("Zoom out")
});